function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#EEEDFC"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 11,
  width: 15,
  height: 19,
  rx: 3,
  fill: "#ECEEFB"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5,
  y: 10.5,
  width: 14,
  height: 18,
  rx: 2.5,
  fill: "#EEEDFC",
  stroke: "#666CA1"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "path-6-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 15.5C16 15.2239 16.2239 15 16.5 15H24.5C24.7761 15 25 15.2239 25 15.5C25 15.7761 24.7761 16 24.5 16H16.5C16.2239 16 16 15.7761 16 15.5Z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 15.5C16 15.2239 16.2239 15 16.5 15H24.5C24.7761 15 25 15.2239 25 15.5C25 15.7761 24.7761 16 24.5 16H16.5C16.2239 16 16 15.7761 16 15.5Z",
  fill: "#C4C4C4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 16H24.5V14H16.5V16ZM24.5 15H16.5V17H24.5V15ZM16.5 15C16.7761 15 17 15.2239 17 15.5H15C15 16.3284 15.6716 17 16.5 17V15ZM24 15.5C24 15.2239 24.2239 15 24.5 15V17C25.3284 17 26 16.3284 26 15.5H24ZM24.5 16C24.2239 16 24 15.7761 24 15.5H26C26 14.6716 25.3284 14 24.5 14V16ZM16.5 14C15.6716 14 15 14.6716 15 15.5H17C17 15.7761 16.7761 16 16.5 16V14Z",
  fill: "#666CA1",
  mask: "url(#path-6-inside-1)"
});

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "path-8-inside-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 24.5C18 24.2239 18.2239 24 18.5 24H24.5C24.7761 24 25 24.2239 25 24.5C25 24.7761 24.7761 25 24.5 25H18.5C18.2239 25 18 24.7761 18 24.5Z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18 24.5C18 24.2239 18.2239 24 18.5 24H24.5C24.7761 24 25 24.2239 25 24.5C25 24.7761 24.7761 25 24.5 25H18.5C18.2239 25 18 24.7761 18 24.5Z",
  fill: "#C4C4C4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 25H24.5V23H18.5V25ZM24.5 24H18.5V26H24.5V24ZM18.5 24C18.7761 24 19 24.2239 19 24.5H17C17 25.3284 17.6716 26 18.5 26V24ZM24 24.5C24 24.2239 24.2239 24 24.5 24V26C25.3284 26 26 25.3284 26 24.5H24ZM24.5 25C24.2239 25 24 24.7761 24 24.5H26C26 23.6716 25.3284 23 24.5 23V25ZM18.5 23C17.6716 23 17 23.6716 17 24.5H19C19 24.7761 18.7761 25 18.5 25V23Z",
  fill: "#666CA1",
  mask: "url(#path-8-inside-2)"
});

var _ref10 = /*#__PURE__*/React.createElement("mask", {
  id: "path-10-inside-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 21.5C18 21.2239 18.2239 21 18.5 21H24.5C24.7761 21 25 21.2239 25 21.5C25 21.7761 24.7761 22 24.5 22H18.5C18.2239 22 18 21.7761 18 21.5Z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18 21.5C18 21.2239 18.2239 21 18.5 21H24.5C24.7761 21 25 21.2239 25 21.5C25 21.7761 24.7761 22 24.5 22H18.5C18.2239 22 18 21.7761 18 21.5Z",
  fill: "#C4C4C4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 22H24.5V20H18.5V22ZM24.5 21H18.5V23H24.5V21ZM18.5 21C18.7761 21 19 21.2239 19 21.5H17C17 22.3284 17.6716 23 18.5 23V21ZM24 21.5C24 21.2239 24.2239 21 24.5 21V23C25.3284 23 26 22.3284 26 21.5H24ZM24.5 22C24.2239 22 24 21.7761 24 21.5H26C26 20.6716 25.3284 20 24.5 20V22ZM18.5 20C17.6716 20 17 20.6716 17 21.5H19C19 21.7761 18.7761 22 18.5 22V20Z",
  fill: "#666CA1",
  mask: "url(#path-10-inside-3)"
});

var _ref13 = /*#__PURE__*/React.createElement("mask", {
  id: "path-12-inside-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 18.5C18 18.2239 18.2239 18 18.5 18H24.5C24.7761 18 25 18.2239 25 18.5C25 18.7761 24.7761 19 24.5 19H18.5C18.2239 19 18 18.7761 18 18.5Z"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M18 18.5C18 18.2239 18.2239 18 18.5 18H24.5C24.7761 18 25 18.2239 25 18.5C25 18.7761 24.7761 19 24.5 19H18.5C18.2239 19 18 18.7761 18 18.5Z",
  fill: "#C4C4C4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 19H24.5V17H18.5V19ZM24.5 18H18.5V20H24.5V18ZM18.5 18C18.7761 18 19 18.2239 19 18.5H17C17 19.3284 17.6716 20 18.5 20V18ZM24 18.5C24 18.2239 24.2239 18 24.5 18V20C25.3284 20 26 19.3284 26 18.5H24ZM24.5 19C24.2239 19 24 18.7761 24 18.5H26C26 17.6716 25.3284 17 24.5 17V19ZM18.5 17C17.6716 17 17 17.6716 17 18.5H19C19 18.7761 18.7761 19 18.5 19V17Z",
  fill: "#666CA1",
  mask: "url(#path-12-inside-4)"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 18.5,
  r: 0.5,
  fill: "#666CA1"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 21.5,
  r: 0.5,
  fill: "#666CA1"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 24.5,
  r: 0.5,
  fill: "#666CA1"
});

const SvgSymptomBadge = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSymptomBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/symptom-badge.dacb0fea.svg";
export { ForwardRef as ReactComponent };